import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { areAddressesSemanticallyEqual } from '../../../address/address-helpers';
import { isAddressVerified } from '../validate-address-helpers';

import { messages } from '../messages';
import style from '../address-validation.module.css';

/**
 * @typedef {object} ShipToAddress
 * @property {string} [name]
 * @property {string} [company]
 * @property {string} [line1]
 * @property {string} [line2]
 * @property {string} [line3]
 * @property {string} [city]
 * @property {string} [state]
 * @property {string} [postalCode]
 * @property {string} [countryCode]
 * @property {string} [phone]
 * @property {string} [verificationStatus]
 */

/**
 * Revert address button component
 * @param {object} props
 * @param {(salesOrderId: string) => void} props.onClick - Callback when revert is clicked
 * @param {string} props.salesOrderId - The sales order ID
 * @param {ShipToAddress} props.shipToAddress - The current ship to address
 * @param {ShipToAddress} [props.marketplaceShipTo] - The original marketplace ship to address
 * @returns {JSX.Element | null}
 */
const Revert = ({ onClick, salesOrderId, shipToAddress, marketplaceShipTo }) => {
  const { verificationStatus } = shipToAddress;
  const revertAddress = useCallback(() => {
    onClick(salesOrderId);
  }, [onClick, salesOrderId]);

  // Show revert when address is verified AND marketplace address exists AND addresses differ
  const doesFpShipToMatchMarketplace = areAddressesSemanticallyEqual(shipToAddress, marketplaceShipTo);
  const canRevert = isAddressVerified(verificationStatus) && marketplaceShipTo && !doesFpShipToMatchMarketplace;

  if (!canRevert) {
    return null;
  }
  return (
    <div className={style['revert-address']}>
      <Button onClick={revertAddress} theme='link'>
        <FormattedMessage {...messages.revert} />
      </Button>
    </div>
  );
};

export { Revert };
